import { useEffect, useRef, type ReactNode } from 'react'
export default function DetailDrawer({ title, subtitle, children, onClose }: { title: string; subtitle?: string; children: ReactNode; onClose: () => void }) {
  const ref = useRef<HTMLDialogElement>(null)
  useEffect(() => { const dialog = ref.current; dialog?.showModal(); return () => { dialog?.close() } }, [])
  return <dialog ref={ref} className="detail-drawer" aria-labelledby="drawer-title" onClick={event => {
    if (event.target !== event.currentTarget) return
    const bounds = event.currentTarget.getBoundingClientRect()
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) onClose()
  }} onCancel={event => { event.preventDefault(); onClose() }}>
    <header><div>{subtitle && <p className="muted">{subtitle}</p>}<h2 id="drawer-title">{title}</h2></div><button className="drawer-close" aria-label="Close details" onClick={onClose} autoFocus>×</button></header>
    <div className="drawer-content">{children}</div>
  </dialog>
}
